import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmWorkforceSkillsRoute } from '@jira/router-routes__products-jsm-workforce-skills-routes/src/productsJsmWorkforceSkillsRoute.tsx';
import { productsJsmWorkforceSkillsEntryPoint } from '@jira/spa-apps__admin-pages-products-jsm-workforce-skills/src/productsJsmWorkforceSkillsEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const isWorkforceAemEnabled = (): boolean =>
	fg('jsm_workforce_use_aem') ? isFeatureEnabled('jira-service-management', 'jsm-workforce') : true;

const entryPoint = createPageEntryPoint({
	main: productsJsmWorkforceSkillsEntryPoint,
});

export const productsJsmWorkforceSkillsRouteEntry: Route = createEntry(
	productsJsmWorkforceSkillsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-workforce-skills',
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		forPaint: [LazyAtlassianNavigation],

		entryPoint: () => {
			if (!isWorkforceAemEnabled() || !fg('jsm_wfo_skills')) {
				return undefined;
			}
			return entryPoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
